import type { GetRelatedExperiencesResponse } from '@/shared/api/experience';
import { type IExpSelection, type SelectionType } from '@/entities/expSelection/model/expSelection';
import { SELECTION_BLOCK_TYPES, SELECTION_TYPE } from '@/entities/expSelection/model/expSelection';
import type { Experience } from '@experience/exp-card/dist/types/experience';

export const transformExperienceSelections = (
  apiResponse: GetRelatedExperiencesResponse | undefined,
): IExpSelection[] => {
  if (!apiResponse) {
    return [];
  }

  return apiResponse.map(
    (selection): IExpSelection => ({
      isAuto: selection.is_auto ?? false,
      expTotalCount: selection.exp_total_count ?? 0,
      experiences: (selection.experiences ?? []).map((exp) => ({
        ...exp,
        isUnderSanctions: exp.is_under_sanctions ?? false,
      })) as Experience[],
      link: selection.link ?? '',
      selectionType: selection.type ?? '',
      subtitle: selection.subtitle ?? '',
      title: selection.title ?? '',
      type: (selection.type as SelectionType) ?? SELECTION_TYPE.TOUR,
      extendedSoguParams: {
        block_type: selection.is_auto ? SELECTION_BLOCK_TYPES.AUTO : SELECTION_BLOCK_TYPES.MANUAL,
        section_name: selection.title ?? '',
        tag_id: selection.extra_data?.tag_id ?? null,
      },
      extra_data: selection.extra_data
        ? {
            tag_id: selection.extra_data.tag_id ?? null,
            tag_slug: (selection.extra_data as { tag_slug?: string | null }).tag_slug ?? null,
          }
        : undefined,
    }),
  );
};
